import {page_json, progress, progress_form_booking, progress_form_login, progress_form_payment} from './feature.progress.svelte.js';
import {booking} from '../booking/feature.booking.svelte.js';
import * as progress_update from './progress.scenarios.update.svelte.js';
import * as progress_select from './progress.scenarios.select.svelte.js';
import * as debug_actions from "../debug/actions_debug.svelte.js";
import * as remote_actions from "../remote/actions_remote.svelte.js";
import * as booker_actions from "../booker/actions_booker.svelte.js";
import * as products_actions from "../products/actions_products.svelte.js";
import * as packagedeals_actions from "../packagedeals/actions_packagedeals.svelte.js";
import * as actions_progress from "./actions_progress.svelte.js";
import {UI_ID_PANEL40_PACKAGEDEAL} from "../../AppConstants.js";
import * as progress_actions from "../progress/actions_progress.svelte.js";
import * as booking_select_export from "../booking/booking.scenarios.select.export.svelte.js";
import * as booking_actions from "../booking/actions_booking.svelte.js";
import AppConfig from "../../AppConfig.js";
import * as products_select from '../products/products.scenarios.select.svelte.js';
import {pulseBackground} from "../../utils/ViewUtils.js";
import {products} from "../products/feature.products.svelte.js";
import * as booking_update from "../booking/booking.scenarios.update.svelte.js";
import {handleCustomerIDInvalid, handleCustomerIDSuccess} from "../booker/actions_booker.svelte.js";
import {booker} from "../booker/feature.booker.svelte.js";

export function setDebugMode(bVal)
{
  debug_actions.debugAddLogFlow('progress', 'setDebugMode', {bVal});
  if ( bVal === true || bVal === false )
  {
    progress.bIsDebugModeEnabled = bVal;
  }
}

export function goToStep(iStepNr)
{
  // console.log('goToStep:', iStepNr);
  debug_actions.debugAddLogFlow('progress', 'goToStep', {iStepNr});
  console.log('goToStep', iStepNr);
  progress_update.scenarioTryToGoToStep(iStepNr);
}

export function goToPrevStep()
{
  if ( progress.bIsLoginScreenActive === true )
  {
    progress_actions.closeLoginForm();
    return;
  }

  const iPrevStepNr = progress_select.getPrevStepNr();
  debug_actions.debugAddLogFlow('progress', 'goToPrevStep', {iPrevStepNr});

  if ( iPrevStepNr )
  {
    console.log('goto prev');
    progress_update.scenarioTryToGoToStep(iPrevStepNr);
  }
}

export function updateNextButtonState(sExplicitValue = false)
{
  // let bDebug = true;
  let bDebug = false;

  if ( bDebug === true ) console.log('updateNextButtonState start');

  if ( sExplicitValue !== false )
  {
    if ( bDebug === true ) console.log('updateNextButtonState explicit value ', sExplicitValue);

    progress.sNextButtonState = sExplicitValue;
    return;
  }

  // active, loading, hidden, disabled
  const iNextStepNr = progress_select.getNextStepNr();
  const oIsNewMoveAllowedReport = progress_select.getValidationReport();

  // window.console.log('updateNextButtonState', iNextStepNr, oIsNewMoveAllowedReport);
  if ( progress.bIsFetchingReservationFeedback !== true && (progress.iCurrentVisibleStep === 60 || progress.iCurrentVisibleStep === 70 || progress.iCurrentVisibleStep === 40) )
  {
    // In het formulier en bij de arrangementen kun je altijd de validatie triggeren
    if ( bDebug === true ) console.log('updateNextButtonState active 1');
    progress.sNextButtonState = 'active';
    return;
  }

  const bBlockNextWhileWaitingForAjax = false;

  if ( oIsNewMoveAllowedReport.iHighestStepWithoutValidationErrors >= iNextStepNr )
  {
    // window.console.log('updateNextButtonState 2 - mag een overgang van ', progress.iCurrentVisibleStep, ' naar ', iNextStepNr);
// console.log('B evalueer button state voor ', progress.iCurrentVisibleStep);
    // de move naar next is toegestaan.. maar het is niet in elk scherm altijd wat we willen aanbieden
    switch ( progress.iCurrentVisibleStep )
    {
      case 10:
        // type boeking
        // de eerste keer dat je hier komt auto-progress na klik.. als je terugklikt naar dit scherm dan wel een knop tonen
        if ( progress.iHighestShownStep === 10 && booking.iPreselectedPackageDealID === false )
        {
          if ( bDebug === true ) console.log('updateNextButtonState hidden 10');
          progress.sNextButtonState = 'hidden';
        }
        else
        {
          //console.log("En dit is dus raar want dit is de afhandeling van 10 terwijl iCurrentVisibleStep al 11 was:", $state.snapshot(progress.iHighestShownStep));
          if ( bDebug === true ) console.log('updateNextButtonState active 10');
          progress.sNextButtonState = 'active';
        }
        break;
      case 11:
        // aantal personen
        // de eerste keer dat je hier komt auto-progress na klik.. als je terugklikt naar dit scherm dan wel een knop tonen
        // Als je binnenkomt met een preselected aantal personen > 1 dan ook meteen de knop tonen
        if ( progress.iHighestShownStep === 11 && booking.lPeople.length === 1 )
        {
          if ( bDebug === true ) console.log('updateNextButtonState hidden 11');
          progress.sNextButtonState = 'hidden';
        }
        else
        {
          if ( bDebug === true ) console.log('updateNextButtonState active 11');
          progress.bHideNextButton = false; // het irritante is dat deze er juist voor zorgt dat als je op het aantal personen klikt je WEL weer de groene knop ziet flitsen
          progress.sNextButtonState = 'active';
        }
        break;
      case 20:
        if ( bDebug === true ) console.log('updateNextButtonState 20');
        // reminder: je zit hier binnen de if dat het report het al toestaat dat je doorgaat
        progress.bHideNextButton = false;
        progress.sNextButtonState = 'active';
        break;
      case 30:
      case 40:
        if ( bDebug === true ) console.log('updateNextButtonState 30 en 40');

        if ( bBlockNextWhileWaitingForAjax === true )
        {
          if ( progress.bIsFetchingPackageDeals === true || progress.bIsFetchingTreatments === true )
          {
            progress.sNextButtonState = 'loading';
          }
          else
          {
            progress.sNextButtonState = 'active';
          }
        }
        else
        {
          progress.sNextButtonState = 'active';
        }

        break;
      case 50:
        if ( bDebug === true ) console.log('updateNextButtonState 50');

        if ( bBlockNextWhileWaitingForAjax === true )
        {
          if ( progress.bIsFetchingPackageDeals === true )
          {
            progress.sNextButtonState = 'loading';
          }
          else
          {
            progress.sNextButtonState = 'active';
          }
        }
        else
        {
          progress.sNextButtonState = 'active';
        }

        break;
      case 60:
        if ( bDebug === true ) console.log('updateNextButtonState 60');

        if ( bBlockNextWhileWaitingForAjax === true )
        {
          if ( progress.bIsFetchingTreatments === true )
          {
            progress.sNextButtonState = 'loading';

          }
          else
          {
            progress.sNextButtonState = 'active';
          }
        }
        else
        {
          progress.sNextButtonState = 'active';
        }

        break;
      case 70:
        if ( progress.bIsFetchingReservationFeedback === true )
        {
          if ( bDebug === true ) console.log('updateNextButtonState loading 70');
          progress.sNextButtonState = 'loading';
        }
        else
        {
          if ( bDebug === true ) console.log('updateNextButtonState active 70');
          progress.sNextButtonState = 'active';
        }

        break;
      default:
        if ( bDebug === true ) console.log('updateNextButtonState active default', progress.iCurrentVisibleStep);
        progress.sNextButtonState = 'active';
    }

    // hier returnen.. de default van de switch heeft het werk al gedaan
    if ( bDebug === true ) console.log('updateNextButtonState return einde switch');
    return;
  }

  // dit is als je nog niet door mag in de huidige stap
  if ( bDebug === true ) console.log('updateNextButtonState hidden fallback');
  progress.sNextButtonState = 'hidden';
}

export function handleNextButtonClick()
{
  // console.log('handleNextButtonClick - shop', $state.snapshot(progress.iCurrentVisibleStep));
  // dit MOET los staan van goToNextStep omdat we in sommige gevallen de afhandeling terug gaan geven aan een formulier,
  // die vervolgens eerst gaat valideren en ALS het form valide is zelf goToNextStep aanroept
  // Bij de pagina's met formulieren roepen we niet rechtstreeks de goToNextStep aan
  // maar laten we het formulier eea afhandelen door eerst te valideren en dan zelf goToNextStep aan te roepen
  switch ( progress.iCurrentVisibleStep )
  {
    case 10:
      // soms is het handig om in stap 10 een formulier te zetten om te debuggen
      if ( progress.bIsLocal === true )
      {
        if ( AppConfig.bLocalTestFormInStep10Booking && progress_form_booking.form !== false )
        {
          progress_form_booking.form.submit();
        }
        else if ( AppConfig.bLocalTestFormInStep10Login && progress_form_login.form !== false )
        {
          progress_form_login.form.submit();
        }
        else if ( AppConfig.bLocalTestFormInStep10Payment && progress_form_payment.form !== false )
        {
          progress_form_payment.form.submit();
        }
        else
        {
          // console.log('next 1');
          progress_actions.goToNextStep();
        }
      }
      else
      {
        // console.log('next 2');
        progress_actions.goToNextStep();
      }
      break;
    case 40:
      progress_actions.handleStep40NextClick();
      break;
    case 60:
      if ( progress_form_booking.form !== false )
      {
        console.log('submit');
        progress_form_booking.form.submit();
      }
      else
      {
        console.log('geen formulier om te submitten');
      }
      break;
    case 70:
      // console.log('handleNextButtonClick - shop 2');
      if ( progress_form_payment.form !== false )
      {
        // console.log('handleNextButtonClick - shop 3');
        progress_form_payment.form.submit();
      }
      break;

    default:
      // console.log('next default');
      progress_actions.goToNextStep();
  }
}

export function goToNextStep()
{
  // console.log('goToNextStep');
  // soms gaan we meteen, soms handelen we eerst nog wat randzaken af
  const iNextStepNr = progress_select.getNextStepNr();
  debug_actions.debugAddLogFlow('progress', 'goToNextStep', {iNextStepNr});

  // console.log('goToNextStep');
  progress_update.scenarioTryToGoToStep(iNextStepNr);
}

export function handleStep40NextClick()
{
  // console.log('handleStep40NextClick', $state.snapshot(progress.oValidationReport.aIncorrectFields));

  // alleen blokkeren als er nog keuzes moeten worden gemaakt in een al toegevoegd arrangement
  if ( progress.oValidationReport.aIncorrectFields[UI_ID_PANEL40_PACKAGEDEAL].length > 0 )
  {
    progress_actions.scrollToAndHighlightPackageDealIfOnStep40();
  }

  progress_actions.goToNextStep();
}

export function scrollToAndHighlightPackageDealIfOnStep40()
{
  let elContainer = document.getElementById("content-page-inner");
  let elScrollTarget = document.getElementById("packagedeal_options_" + booking.iCurrentSelectedPackagedealID);

  if ( elContainer && elScrollTarget )
  {
    // Methode 1: Gebruik scrollIntoView voor een vloeiende scroll
    // elScrollTarget.scrollIntoView({behavior: 'smooth', block: 'start'});

    // Methode 2: Bereken de offset en scroll direct
    elContainer.scrollTo({top: (elScrollTarget.offsetTop - 30), behavior: 'smooth'});

    pulseBackground("packagedeal_options_" + booking.iCurrentSelectedPackagedealID);
  }

}

export function shortcutToForm()
{
  debug_actions.debugAddLogFlow('progress', 'shortcutToForm');
  const iStepToGoTo = 50;
  progress.iCurrentVisibleStep = iStepToGoTo;
  progress.iHighestShownStep = iStepToGoTo;
}

export function submitOrder()
{
  debug_actions.debugAddLogFlow('progress', 'submitOrder');
  progress_update.scenarioTryToSubmitToServer();
}

export function openReceiptDialog()
{
  progress.bIsReceiptDialogOpen = true;
}

export function closeReceiptDialog()
{
  progress.bIsReceiptDialogOpen = false;
}


export function handleProductTimeSlotPopupClosed()
{
  // eventuele opruimwerkzaamheden
  progress_actions.resetProductTimeSlotPopup();
}

export function resetProductTimeSlotPopup()
{
  // eventuele opruimwerkzaamheden
  progress.oTimeSlotPopup.aAvailableSlots = false;
  progress.oTimeSlotPopup.bIsOpen = false;
  progress.oTimeSlotPopup.iProductID = false;
  progress.oTimeSlotPopup.oPerson = false
}

// De reden dat onderstaande api functies hier staan en niet direct naar actions_remote.svelte.js gaan
// is dat in actions_remote puur de aanroep naar de remote endpoints staan en in deze file hier ook
// de side effects voor elke aanroep worden afgehandeld. Door de aanroep zelf geisoleerd in actions_remote
// te hebben blijft er de mogelijkheid om zo'n aanroep ook los aan te roepen zonder alle gangbare side effects.
export async function apiCallRequestWidgetData(fnCallback)
{
  debug_actions.debugAddLogFlow('progress', 'apiCallRequestWidgetData');
  // progress.sFetchingError = null;
  await remote_actions.fetchWidgetData(fnCallback);
}

export async function apiCallRequestPageData(fnCallback)
{
  debug_actions.debugAddLogFlow('progress', 'apiCallRequestPageData');
  // progress.sFetchingError = null;
  await remote_actions.fetchPageData(fnCallback);
}

export async function apiCallRequestCalendar(fnCallback)
{
  debug_actions.debugAddLogFlow('progress', 'apiCallRequestCalendar');
  progress.bIsFetchingCalendar = true;
  // progress.sFetchingError = null;
  await remote_actions.fetchCalendar(fnCallback);
  progress.bIsFetchingCalendar = false;
}

export async function apiCallRequestCalendarForWidgets(fnCallback)
{
  debug_actions.debugAddLogFlow('progress', 'apiCallRequestCalendarForWidgets');
  progress.bIsFetchingCalendar = true;
  // progress.sFetchingError = null;
  await remote_actions.fetchCalendarForWidgets(fnCallback);
  progress.bIsFetchingCalendar = false;
}

export async function apiCallRequestAvailability(iProductID, sPersonID)
{
  // console.log('debug avail start', iProductID, sPersonID);
  debug_actions.debugAddLogFlow('progress', 'apiCallRequestCalendar');
  // progress.bIsFetchingPackageDeals = true;
  // progress.sFetchingError = null;
  const oBookingExport = booking_select_export.getBookingExport(true);
  const aBookedProductsAndTimes = [];

  oBookingExport.aPeople.forEach((oPersonConfig) => {
    oPersonConfig.allProducts.forEach((oProductForPersonConfig) => {
      let oProduct = products_select.getProductByID(oProductForPersonConfig.iID);

      if ( oProduct && oProduct.bIsTreatment === true )
      {
        if ( iProductID === oProductForPersonConfig.iID && sPersonID === oPersonConfig.sID )
        {
          // het product waar het in de call om gaat moet voor de persoon die we willen plannen zelf UIT de export worden gehaald, maar andere personen die hem hebben moeten er wel in
          return;
        }

        let oBookedProductandTime = {
          iID: oProductForPersonConfig.iID
        };

        // NB we sturen dus alleen behandelingen mee waar een tijdsvoorkeur voor is ingesteld (nogmaals besproken SvS/JB 202509)
        if ( typeof oProductForPersonConfig.sTime !== "undefined" && oProductForPersonConfig.sTime !== 'x' && oProductForPersonConfig.sTime !== 'y' )
        {
          oBookedProductandTime.sTime = oProductForPersonConfig.sTime;
        }

        aBookedProductsAndTimes.push(oBookedProductandTime);
      }
    });
  });

  progress.oTimeSlotPopup.aAvailableSlots = false;
// console.log('debug avail', aBookedProductsAndTimes);
  let oResponse = await remote_actions.fetchProductAvailability(iProductID, booking.sArrivalDate, booking.sArrivalDate, booking.iArrivalTime, booking.iDepartureTime, JSON.stringify(aBookedProductsAndTimes));

  if ( parseInt(oResponse.iID) === progress.oTimeSlotPopup.iProductID )
  {
    progress.oTimeSlotPopup.sDebug = oResponse.sDebug;
    progress.oTimeSlotPopup.sTitle = oResponse.sTitle;
    progress.oTimeSlotPopup.aAvailableSlots = oResponse.aTimeSlots; // keys L en V

    if ( progress.oTimeSlotPopup.aAvailableSlots.length === 0 && AppConfig.bDebugUseFakeAjaxCalls === true )
    {
      progress.oTimeSlotPopup.aAvailableSlots = [
        {V: "1100", L: "Om 11:00"},
        {V: "1200", L: "Om 12:00"},
        {V: "1300", L: "Om 13:00"},
        {V: "1400", L: "Om 14:00"}
      ];
    }
  }
  else
  {
    window.console.log("Negereer productdata omdat het voor een vorig product is.")
  }
}

export async function apiCallRequestRestaurantAvailability(sPersonID)
{
  // console.log('debug avail rest start', sPersonID);
  debug_actions.debugAddLogFlow('progress', 'apiCallRequestRestaurantAvailability');

  progress.bIsFetchingRestaurant = true;

  const oBookingExport = booking_select_export.getBookingExport(true);
  const aBookedProductsAndTimes = [];

  oBookingExport.aPeople.forEach((oPersonConfig) => {
    oPersonConfig.allProducts.forEach((oProductForPersonConfig) => {
      let oProduct = products_select.getProductByID(oProductForPersonConfig.iID);

      if ( oProduct && oProduct.bIsTreatment === true )
      {
        if ( AppConfig.iDinnerProductID === oProductForPersonConfig.iID )
        {
          // het dinner product waar het in de call om gaat moet UIT de export worden gehaald
          return;
        }

        let oBookedProductandTime = {
          iID: oProductForPersonConfig.iID
        };

        // NB we sturen dus alleen behandelingen mee waar een tijdsvoorkeur voor is ingesteld (nogmaals besproken SvS/JB 202509)
        if ( typeof oProductForPersonConfig.sTime !== "undefined" && oProductForPersonConfig.sTime !== 'x' && oProductForPersonConfig.sTime !== 'y' )
        {
          oBookedProductandTime.sTime = oProductForPersonConfig.sTime;
        }

        aBookedProductsAndTimes.push(oBookedProductandTime);
      }
    });
  });

  // console.log('debug avail rest', aBookedProductsAndTimes);

  let oResponse = await remote_actions.fetchRestaurantProductAvailability(booking.sArrivalDate, booking.sArrivalDate, booking.iArrivalTime, booking.iDepartureTime, JSON.stringify(aBookedProductsAndTimes));

  //oResponse.sDebug;
  ///oResponse.sTitle;

  // We hebben de tijdslots teruggekregen, maar we moeten nog kijken welke tijdslots nog plek hebben voor het aantal personen in deze boeking
  if ( oResponse.aTimeSlots === false || oResponse.aTimeSlots === null )
  {
    products.aAvailableRestaurantTimes = [];
  }
  else
  {
    let aFilteredTimeSlotConfigs = [];
    let iNrOfPeople = booking.lPeople.length;

    oResponse.aTimeSlots.forEach((oTimeSlotConfig) => {
      // keys L en V en P voor het aantal plekken dat beschikbaar is in dat slot
      let iNrOfPlacesInSlot = parseInt(oTimeSlotConfig.P);

      if ( iNrOfPlacesInSlot >= iNrOfPeople )
      {
        aFilteredTimeSlotConfigs.push(oTimeSlotConfig);
      }
    });

    products.aAvailableRestaurantTimes = aFilteredTimeSlotConfigs;
  }

  if ( progress.oTimeSlotPopup.aAvailableSlots.length === 0 && AppConfig.bDebugUseFakeAjaxCalls === true )
  {
    progress.oTimeSlotPopup.aAvailableSlots = [
      {V: "1100", L: "Om 11:00"},
      {V: "1200", L: "Om 12:00"},
      {V: "1300", L: "Om 13:00"},
      {V: "1400", L: "Om 14:00"}
    ];
  }

  progress.bIsFetchingRestaurant = false;
}

export async function apiCallRequestPackageDealsDummy()
{
  debug_actions.debugAddLogFlow('progress', 'apiCallRequestPackageDealsDummy');
  progress.bIsFetchingPackageDeals = true;
  progress_actions.updateNextButtonState();

  progress.sFetchingError = null;
  // er zijn geen meerdaagse arrangementen
  const oRemoteResponse = await remote_actions.fetchPackageDeals(booking.sArrivalDate, booking.sArrivalDate, booking.iArrivalTime, booking.iDepartureTime, true)
  packagedeals_actions.importFromOfAjaxCall(oRemoteResponse);
  //window.console.log('apiCallRequestPackageDeals', oRemoteResponse);
  // booking_update_receipt.calculateBookingTotals();
  booking_actions.handleBookingUpdated('apiCallRequestPackageDealsDummy');
}

export async function apiCallRequestPackageDeals(fnCallback)
{
  debug_actions.debugAddLogFlow('progress', 'apiCallRequestPackageDeals');
  progress.bIsFetchingPackageDeals = true;
  progress_actions.updateNextButtonState();

  progress.sFetchingError = null;
  // er zijn geen meerdaagse arrangementen
  const oRemoteResponse = await remote_actions.fetchPackageDeals(booking.sArrivalDate, booking.sArrivalDate, booking.iArrivalTime, booking.iDepartureTime)
  packagedeals_actions.importFromOfAjaxCall(oRemoteResponse);
  //window.console.log('apiCallRequestPackageDeals', oRemoteResponse);
  progress.bIsFetchingPackageDeals = false;
  // booking_update_receipt.calculateBookingTotals();
  booking_actions.handleBookingUpdated('apiCallRequestPackageDeals');

  if ( typeof fnCallback === "function" )
  {
    fnCallback();
  }
}

export async function apiCallPackageDealsFailure(error)
{
  debug_actions.debugAddLogFlow('progress', 'apiCallPackageDealsFailure', {error});
  progress.bIsFetchingPackageDeals = false;
  progress.htmlPackageDeals = null;
  progress.sFetchingError = error;
  progress_actions.updateNextButtonState();
}

export async function apiCallRequestTreatmentsDummy()
{
  //window.console.log('naar apiCallRequestTreatments 1');
  debug_actions.debugAddLogFlow('progress', 'apiCallRequestTreatmentsDummy');
  progress.bIsFetchingTreatments = true;
  progress_actions.updateNextButtonState();

  progress.sFetchingError = null;
  const oRemoteResponse = await remote_actions.fetchTreatments(booking.sArrivalDate, booking.sArrivalDate, booking.iArrivalTime, booking.iDepartureTime, true);
  products_actions.importFromOfAjaxCall(oRemoteResponse);
  //window.console.log('apiCallRequestPackageDeals', oRemoteResponse);
  // booking_update_receipt.calculateBookingTotals();
  booking_actions.handleBookingUpdated('apiCallRequestTreatmentsDummy');
}

export async function apiCallRequestTreatments(fnCallback)
{
  //window.console.log('naar apiCallRequestTreatments 1');
  debug_actions.debugAddLogFlow('progress', 'apiCallRequestTreatments');
  progress.bIsFetchingTreatments = true;
  progress_actions.updateNextButtonState();

  progress.sFetchingError = null;
  const oRemoteResponse = await remote_actions.fetchTreatments(booking.sArrivalDate, booking.sArrivalDate, booking.iArrivalTime, booking.iDepartureTime);
  products_actions.importFromOfAjaxCall(oRemoteResponse);

  // bij binnenkomen nieuwe behandeldata voor de dag dan alle tijden bij behandelingen clearen
  // en alle niet choiceid 0 behandelingen weg die bIsAvailable !== true
  booking_update.removeAllTimeSlotChoices();
  booking_update.removeUnavailableTreatments();

  //window.console.log('apiCallRequestPackageDeals', oRemoteResponse);
  progress.bIsFetchingTreatments = false;
  // booking_update_receipt.calculateBookingTotals();
  booking_actions.handleBookingUpdated('apiCallRequestTreatments');

  if ( typeof fnCallback === "function" )
  {
    fnCallback();
  }
}

export async function apiCallTreatmentsFailure(error)
{
  debug_actions.debugAddLogFlow('progress', 'apiCallTreatmentsFailure', {error});
  progress.bIsFetchingTreatments = false;
  progress.htmlTreatments = null;
  progress.sFetchingError = error;
  progress_actions.updateNextButtonState();
}

export async function apiCallRequestCustomerID(sEmail, sPassword, fnCallback)
{
  // console.log('apiCallRequestCustomerID', sEmail, sPassword);
  debug_actions.debugAddLogFlow('progress', 'customerIdRemoteGetRequest', {sEmail, sPassword});
  progress.bIsFetchingLogin = true;
  progress_actions.updateNextButtonState();
// console.log('oRemoteResponse 0:');
  const oRemoteResponse = await remote_actions.fetchCustomerID(sEmail, sPassword);
// console.log('oRemoteResponse 1:', oRemoteResponse);
  if ( oRemoteResponse )
  {
    console.log('oRemoteResponse 2:', oRemoteResponse);
    if ( oRemoteResponse.bIsValid === true )
    {

      debug_actions.debugAddLogFlow('progress', 'customerIdRemoteGetSuccess');
      progress.sFetchingLoginError = false;
      progress.bIsFetchingLogin = false;
      progress_actions.updateNextButtonState();
      booker_actions.handleCustomerIDSuccess(oRemoteResponse);
      progress.iLoginScreenComponentRefreshCounter += 1;

      if ( typeof fnCallback === "function" )
      {
        fnCallback();
      }
    }
    else
    {
      debug_actions.debugAddLogFlow('progress', 'customerIdRemoteGetInvalid');
      progress.sFetchingLoginError = 'Deze inloggegevens kloppen niet, probeer het opnieuw';
      progress.bIsFetchingLogin = false;
      progress_actions.updateNextButtonState();
    }
  }
  else
  {
    debug_actions.debugAddLogFlow('progress', 'customerIdRemoteGetFailure');
    progress.bIsFetchingLogin = false;
    progress_actions.updateNextButtonState();
    booker_actions.handleCustomerIDInvalid();
  }
}


export function openLoginForm()
{
  debug_actions.debugAddLogFlow('progress', 'openLoginForm');
  progress.bIsLoginScreenActive = true;
}

export function closeLoginForm()
{
  debug_actions.debugAddLogFlow('progress', 'closeLoginForm');
  progress.bIsLoginScreenActive = false;
}

export function importFromPageConfigAjaxCall()
{
  if ( typeof page_json.data.jsonHmkCustomerUrl !== 'undefined' && page_json.data.jsonHmkCustomerUrl !== 'false' && page_json.data.jsonHmkCustomerUrl !== false ) progress.sFetchCustomerAPIEndpoint = page_json.data.jsonHmkCustomerUrl;
  if ( typeof page_json.data.jsonHmkPasswordUrl !== 'undefined' && page_json.data.jsonHmkPasswordUrl !== 'false' && page_json.data.jsonHmkPasswordUrl !== false ) progress.sURLPassword = page_json.data.jsonHmkPasswordUrl;
  if ( typeof page_json.data.jsonHmkPrivacyUrl !== 'undefined' && page_json.data.jsonHmkPrivacyUrl !== 'false' && page_json.data.jsonHmkPrivacyUrl !== false ) progress.sURLPrivacy = page_json.data.jsonHmkPrivacyUrl;
  if ( typeof page_json.data.jsonHmkHouseholdRulesUrl !== 'undefined' && page_json.data.jsonHmkHouseholdRulesUrl !== 'false' && page_json.data.jsonHmkHouseholdRulesUrl !== false ) progress.sURLHouseholdRules = page_json.data.jsonHmkHouseholdRulesUrl;
  if ( typeof page_json.data.jsonHmkInsuranceUrl !== 'undefined' && page_json.data.jsonHmkInsuranceUrl !== 'false' && page_json.data.jsonHmkInsuranceUrl !== false ) progress.sURLInsurance = page_json.data.jsonHmkInsuranceUrl;

}

export function openGenericDialog(sTitle, sContent)
{
  progress.sDialogTitle = sTitle;
  progress.sDialogContent = '<div>' + sContent + '</div>';
  progress.bIsDialogOpen = true;
}

export function closeGenericDialog()
{
  progress.bIsDialogOpen = true;
  progress.sDialogTitle = '';
  progress.sDialogContent = '';
}

export function openPackageDealDialog(iPackageDealID)
{
  progress.iPackageDialogPackageDealID = iPackageDealID;
  progress.bIsPackageDealDialogOpen = true;
}

export function closePackageDealDialog()
{
  progress.bIsPackageDealDialogOpen = true;
  progress.iPackageDialogPackageDealID = 0;
}

export function openProductDialog(iProductID)
{
  console.log('openProductDialog', iProductID);
  progress.iProductDialogProductID = iProductID;
  progress.bIsProductDialogOpen = true;
}

export function closeProductDialog()
{
  progress.bIsProductDialogOpen = true;
  progress.iProductDialogProductID = 0;
}

export function closeAllDialogs()
{
  actions_progress.closeGenericDialog();
  actions_progress.closeProductDialog();
  actions_progress.closePackageDealDialog();
}